import { LastUpdatedDateWrapper } from './styled';

type LastUpdatedDateProps = {
  lastUpdatedDateText: string;
};

const LastUpdatedDate = ({ lastUpdatedDateText }: LastUpdatedDateProps): JSX.Element => (
  <LastUpdatedDateWrapper data-testid="lastUpdatedDate">{lastUpdatedDateText}</LastUpdatedDateWrapper>
);

export default LastUpdatedDate;
